/*SYSTEM IMPORTS*/
import React, { PureComponent } from "react"
import c from "classnames"

/*VIEWS*/
import Burger from "components/Burger"
import Img from "components/Img"

/*HELPERS*/
import { ConnectReduxWith } from "helpers/Redux/connectRedux"
import LayoutWindow from "mixins/LayoutWindow"

/*CORE*/
import AppCore from "cores/AppCore"

/*UI*/
import ActionWrapp from "components/ui/ActionWrapp"
import Btn from "components/ui/Btn"
import { HeaderMenuItem, HeaderMobileMenuItem } from "components/ui/Header"

/*IMAGE*/
import BtnIcons from "images/btn-icons.svg"

@ConnectReduxWith("ui", "settings", "routing")
@LayoutWindow
class Header extends PureComponent {
    handleToggleMobileMenu = () => {
        AppCore.ui.toggleMobileMenu()
    }

    render() {
        const {
            scrollTop = 0,
            children = null,
            title = "",
            link = "/",
            className,
        } = this.props

        const { ui = false } = this.props

        const { open_mobile_menu = false } = ui

        return (
            <header
                key={"header"}
                className={c("header", { fixed: scrollTop > 10 }, className)}
            >
                <div className="header__top-panel">
                    <div className="container header__container">
                        <Burger onClick={this.handleToggleMobileMenu} />
                        <div className="header__content">
                            <div className="header__menu">
                                <div className="header__list-menu">
                                    <HeaderMenuItem text="Обо мне" active />
                                    <HeaderMenuItem text="Образование" />
                                    <HeaderMenuItem text="Ответы на SKIN.EXPERT " />
                                    <HeaderMenuItem text="Место работы" />
                                    <HeaderMenuItem text="Обратная связь" />
                                </div>
                                <ActionWrapp>
                                    <Btn
                                        className="btn-chat"
                                        image={<Img src={BtnIcons} div />}
                                    >
                                        Написать в чат
                                    </Btn>
                                    <Btn
                                        className="btn-video"
                                        image={<Img src={BtnIcons} div />}
                                    >
                                        Видеозвонок
                                    </Btn>
                                </ActionWrapp>
                            </div>
                        </div>
                    </div>
                </div>
                {open_mobile_menu && (
                    <div className="header__mobile-menu">
                        <div className="mobile-menu_block">
                            <HeaderMobileMenuItem text="Обо мне" active />
                            <HeaderMobileMenuItem text="Образование" />
                            <HeaderMobileMenuItem text="Ответы на SKIN.EXPERT " />
                            <HeaderMobileMenuItem text="Место работы" />
                            <HeaderMobileMenuItem text="Обратная связь" />
                        </div>
                    </div>
                )}
            </header>
        )
    }
}

export default Header
